import axios from "axios";
import { Blog, BlogSources } from "types/blogs";
import { GetAllResponse } from "types/getAllResponse";
import { Highlight } from "types/highlights";

export const orchestrator = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL_TO_ORCHESTRATOR,
});

// Hub-Db Controller
export const getBlogs = () => {
  const page = 1;
  const source: BlogSources = "otl";
  const order = "ASC";

  const query = `?page=${page}&limit=${Number.MAX_SAFE_INTEGER}&source=${source}&order=${order}`;

  const blogs = orchestrator.get<GetAllResponse<Blog>>(`blogs/public${query}`);
  return blogs;
};
export const getBlog = ({ id }: { id: number }) => {
  return orchestrator.get<Blog>(`blogs/public/${id}`);
};
export const getHighlights = () => {
  const page = 1;
  const limit = Number.MAX_SAFE_INTEGER;

  // If needed, include source and order — based on backend support
  const source: BlogSources = "otl";
  const order = "ASC";

  const query = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
    source,
    order,
  }).toString();

  return orchestrator.get<GetAllResponse<Highlight>>(
    `/highlight/public?${query}`
  );
};
